angular.module('zc.zenclerkS')
  .directive('fullySupportedAspOnly', fullySupportedAspOnly);

fullySupportedAspOnly.$inject = [];
function fullySupportedAspOnly() {
  return {
    restrict: 'A',
    controller: fullySupportedAspOnlyController
  };
}

fullySupportedAspOnlyController.$inject = ['$element', '$scope', '$stateParams', 'Devise', 'ZcsProject'];
function fullySupportedAspOnlyController($element, $scope, $stateParams, Devise, ZcsProject) {
  const originalDisplay = $element.css('display');

  $element.css('display', 'none');

  $scope.$stateParams = $stateParams;

  const cartAsp = [
    'makeshop'
  ];

  $scope.$watch('$stateParams.apikey', () => {
    if(!$stateParams.apikey) return;

    ZcsProject.get(Devise.currentUser.id, $stateParams.apikey)
      .then(project => {
        if( _.includes(cartAsp, project.shopping_cart_asp) || project.show_item_stats) {
          $element.css('display', originalDisplay);
        }
      });
  });
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/fully_supported_asp_only/fully_supported_asp_only.directive.js